<template>

  <b-modal id="UsuarioUpdateAvatar" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Subir Avatar</h5>
      <button type="button" aria-label="Close" class="close" @click="close()" :disabled="loading">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="editar" ref="form">

        <div class="final_form_container">

          <file-selector
            accept-extensions=".jpg,.png"
            :multiple="false"
            :is-loading="loading"
            :max-file-size="500 * 1024"
            @validated="handleFilesValidated"
            @changed="handleFilesChanged"
          >
            Seleccionar imagen

            <div slot="top" class="section-top">
              <p style="font-size: 1rem;">
                Arrastre aquí una imagen (JPG o PNG) de máximo 500 KB
              </p>
              o
            </div>

            <div slot="loader" class="section-loader">
              Procesado imagen<br/>
              por favor espere...
            </div>
            
          </file-selector>
          

          <div class="gallery" v-if="gallery.length">
            <div
              v-for="(img, index) in gallery"
              class="gallery-item"
              :key="index"
            >
              <div class="img"><img :src="img.src"></div>
              <div class="img-info">
                <div class="img-name" :title="img.name">{{ img.name }}</div>
                <div class="img-size">{{ formatNumber(img.size) }} bytes</div>
              </div>
            </div>
          </div>


          
          <!--<div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Seleccionar Archivo</label>
              <b-form-input class="inputText" v-model="avatar" type="text" autofocus="autofocus" required :disabled="loading"></b-form-input>
          </div>-->

         </div>

        <div class="modal-footer">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>


export default {
  components: {
    
  },
  data () {
    return {
      loading: false,
      avatar: '',
      gallery: []
    }
  },
  methods: {
    handleFilesValidated(result, files) {
      if (result != true) {
        this.showError("El archivo no es adecuado")
      }
    },
    async handleFilesChanged(files) {
      this.loading = true;
      // console.log('Selected files: ');
      // console.table(files);

      this.gallery = [];

      const list = Array.from(files);
      for (const file of list) {
        const img = await this.loadImgAsDataUrl(file);
        this.avatar = img;
        this.gallery.push({
          name: file.name,
          size: file.size,
          src: img,
        });
      }
      this.loading = false;
    },
    async loadImgAsDataUrl(file) {
      const url = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => resolve(e.target.result);
      });
      return url;
    },
    formatNumber(num) {
      return new Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(num);
    },
    editar () {
      try {

        this.loading = true

        if (this.avatar != '' && this.avatar != undefined) {

          this.$http.secured.put(`/auth/v1/users/${localStorage.id}`, { type: "change_avatar", avatar: this.avatar })
            .then(response => {

              localStorage.avatar = response.data;
              this.avatar = '';
              this.gallery = [];

              this.loading = false
              this.showOK("Se actualizó el avatar correctamente!")
              this.$emit('closeModal')
              this.$refs.modal.hide()
            })
            .catch(error => {
              this.loading = false
              this.showError(error)
            })

        } else {
          this.loading = false
        this.showError("Debe elegir una imagen")
        }

      } catch (error) {
        this.loading = false
        this.showError(error)
      }
    }
  }
}
</script>
<style lang="scss">
.fs-file-selector {
  margin-top: 1rem;
  text-align: center;
  -webkit-backdrop-filter: blur(35px) saturate(200%);
  backdrop-filter: blur(35px) saturate(200%);
  border-radius: 5px;
  border-width: 1px;
  border-color: gray;
  border-style: dashed;
  .fs-droppable {
    padding: 1.5rem;
    transition: all ease 200ms;
  }
  .fs-btn-select {
    background-color: #0792d3;
    padding: 0.75rem 2rem;
    color: #fff;
    border-radius: 5px;
    font-family: nunito;
    transition: all ease 200ms;
    &:hover {
      cursor: pointer;
      background-color: lighten(#006c9e, 5);
    }
    &:active {
      background-color: darken(#006c9e, 5);
      transform: scale(0.95);
      transition: all ease 60ms;
    }
  }
  .fs-loader {
    background-color: transparent !important;
  }
  &.fs-drag-enter {
    background-color: rgba(black, 0.1);
    .fs-droppable {
      transition: all ease 100ms;
      transform: scale(0.98);
    }
  }
}
.btn-back {
  display: inline-block;
  padding: 1rem 0;
  position: sticky;
  top: 1rem;
  z-index: 10;
  font-weight: 600;
}
.section-top {
  margin-bottom: 2rem;
  font-size: 1rem;
  font-family: nunito;
}
.section-bottom {
  margin-top: 2rem;
  font-family: nunito;
  font-size: 1rem;
}
.section-loader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease 300ms;
  background-color: rgba(#fff, 0.9);
  backdrop-filter: blur(20px);
}
.gallery {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  .gallery-item {
    height: auto;
    overflow: hidden;
    display: grid;
    grid-template-rows: 1fr -webkit-min-content;
    grid-template-rows: 1fr min-content;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 5px;
    padding: 10px;
    .img {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100px;
        max-height: 100px;
      }
    }
    .img-info {
      margin: 1rem 0;
      overflow: hidden;
      text-align: center;
      .img-name {
        font-family: nunito;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 0.875rem;
        max-width: 100%;
        overflow: hidden;
        padding: 0 1rem;
      }
      .img-size {
        font-family: nunito;
        font-size: 0.75rem;
        text-align: center;
        padding: 0 1rem;
      }
    }
  }
}
</style>